import { MemoizedReactMarkdown } from '@/Components/Common/Markdown/Markdown';
import { MarkdownComponents } from '@/Components/Common/Markdown/Markdown.components';
import { useState } from 'react';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import { parse } from 'tldts'; //This is to identify domains accurately withuth subdomain problems, for example, es.wikipedia.org -> Wikipedia

const MetaContent = ({ loading, reasoning, annotations }) => {
  const [reasoningOpen, setReasoningOpen] = useState(true); //Controls the reasoning callapsable
  const [annotationsOpen, setAnnotationsOpen] = useState(true); //controls anotations collapsable
  return (
    <>
      <div class="flex flex-col space-x-4">
        <div class="flex flex-row gap-x-3">
          {annotations &&
            Array.isArray(annotations) &&
            annotations.length > 0 && (
              <div
                className="flex rounded-lg py-1 px-2 mt-2 gap-2 bg-lavender text-violet-blue dark:text-tropical-indigo  w-fit text-xs items-center cursor-pointer"
                onClick={() => setAnnotationsOpen(!annotationsOpen)}
              >
                <img
                  src="/svg/gears.svg"
                  alt="Gears"
                  height="18px"
                  width="18px"
                />
                <span>
                  <strong>References</strong>
                </span>
                <span>{annotationsOpen ? '▼' : '▲'}</span>
              </div>
            )}
          {reasoning && reasoning.trim() !== '' && (
            <div
              className="flex rounded-lg py-1 px-2 mt-2 gap-2 bg-lavender text-violet-blue dark:text-tropical-indigo  w-fit text-xs items-center cursor-pointer"
              onClick={() => setReasoningOpen(!reasoningOpen)}
            >
              <img
                src="/svg/gears.svg"
                alt="Gears"
                height="18px"
                width="18px"
              />
              <span>
                <strong>
                  {loading ? 'Reasoning...' : 'Reasoning Finished'}
                </strong>
              </span>
              <span>{reasoningOpen ? '▼' : '▲'}</span>
            </div>
          )}
        </div>
        {annotationsOpen &&
          Array.isArray(annotations) &&
          annotations.length > 0 && (
            <div className="flex items-stretch gap-4 mt-4">
              <div className="flex overflow-x-auto space-x-4 py-2">
                {annotations.map((annotation, index) => {
                  const domain = parse(
                    annotation.url_citation.url
                  ).domainWithoutSuffix;
                  const displayDomain = domain
                    ? domain.charAt(0).toUpperCase() + domain.slice(1) //Domain with capital letter
                    : '';

                  return (
                    <a
                      key={index}
                      href={annotation.url_citation.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="block min-w-[250px] max-w-[300px] max-h-[250px] border-[3px] border-gray-300 dark:border-gray-500 rounded-xl p-4 shadow-sm overflow-hidden hover:bg-gray-100 dark:hover:bg-gray-800 transition"
                    >
                      <h2 className="text-lg mb-2 break-words text-gray-500 dark:text-gray-300">
                        <strong>
                          <span className="text-gray-500 mr-2 bg-gray-300 rounded px-1 py-0.1">
                            {index + 1}
                          </span>
                          {displayDomain}
                        </strong>
                      </h2>
                      <p className="text-sm text-gray-500 dark:text-gray-400 break-words underline">
                        {annotation.url_citation.url}
                      </p>
                    </a>
                  );
                })}
              </div>
            </div>
          )}
        {reasoningOpen && reasoning && (
          <div className="flex items-stretch gap-4 mt-4 ">
            {/* vertical reasoning bar */}
            <div className="w-1.5 bg-gray-400 dark:bg-gray-400 flex-none"></div>
            <p>
              <MemoizedReactMarkdown
                className="mt-3 text-gray-300 dark:text-gray-500 [&>*]:!text-gray-400"
                remarkPlugins={[remarkGfm, remarkMath]}
                rehypePlugins={[rehypeRaw]}
                components={MarkdownComponents}
              >
                {
                  reasoning.replace(
                    /\\n/g,
                    '<br />'
                  ) /*Show reasoning and fixes possible markdown line break issues*/
                }
              </MemoizedReactMarkdown>
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default MetaContent;
